
/* Constant file for all possible user subscription plans.
 * TODO: does this cover all the plans? Include any missing.
 */
export class SubscriptionPlan {
    public static readonly FREE_TRIAL = 'FreeTrial';
    public static readonly BASIC = 'Basic';
    public static readonly PROFESSIONAL = 'Professional';
    public static readonly ENTERPRISE = 'Enterprise';
    public static readonly ICA = 'Ica';
    public static readonly ICS_FREE_TRIAL = 'IcsFreeTrial';
    public static readonly ICS_PAY_AS_YOU_GO = 'IcsPayAsYouGo';
    public static readonly NONE = 'None';

    public static isFreeTrialLike(plan: string): boolean {
        return plan === SubscriptionPlan.FREE_TRIAL ||
               plan === SubscriptionPlan.ICS_FREE_TRIAL;
    }
}
